<template>
    <v-card>
        <v-card-text>
            <v-row dense align="center">
                <v-col cols="12" sm="6" md="2">
                    <v-select dense outlined hide-details label="Período" :items="presets" v-model="preset" @change="applyPreset" />
                </v-col>
                <v-col cols="12" sm="6" md="2">
                    <v-text-field dense outlined hide-details type="date" label="De" v-model="range.start" @change="preset = 'custom'" />
                </v-col>
                <v-col cols="12" sm="6" md="2">
                    <v-text-field dense outlined hide-details type="date" label="Até" v-model="range.end" @change="preset = 'custom'" />
                </v-col>
                <v-col cols="12" sm="6" md="auto">
                    <v-btn color="primary" elevation="0" :loading="loading" @click="emit">Filtrar</v-btn>
                </v-col>
                <v-spacer />
                <v-col cols="12" md="auto" class="caption grey--text">
                    Por competência: viagens pela data, despesas pelo mês de competência.
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
</template>

<script>
import moment from 'moment'

// Filtro de período das telas de relatório do financeiro (meses fechados)
export default {
    name: 'PeriodFilter',

    props: {
        loading: { type: Boolean, default: false },
        initial: { type: String, default: 'last6' }
    },

    data() {
        return {
            preset: this.initial,
            range: { start: null, end: null },
            presets: [
                { value: 'month', text: 'Este mês' },
                { value: 'lastMonth', text: 'Mês passado' },
                { value: 'last3', text: 'Últimos 3 meses' },
                { value: 'last6', text: 'Últimos 6 meses' },
                { value: 'last12', text: 'Últimos 12 meses' },
                { value: 'year', text: 'Este ano' },
                { value: 'lastYear', text: 'Ano passado' },
                { value: 'custom', text: 'Personalizado' }
            ]
        }
    },

    created() {
        this.applyPreset(this.preset)
    },

    methods: {
        applyPreset(preset) {
            const now = moment()
            const ranges = {
                month: [now.clone().startOf('month'), now.clone().endOf('month')],
                lastMonth: [now.clone().subtract(1, 'month').startOf('month'), now.clone().subtract(1, 'month').endOf('month')],
                last3: [now.clone().subtract(2, 'months').startOf('month'), now.clone().endOf('month')],
                last6: [now.clone().subtract(5, 'months').startOf('month'), now.clone().endOf('month')],
                last12: [now.clone().subtract(11, 'months').startOf('month'), now.clone().endOf('month')],
                year: [now.clone().startOf('year'), now.clone().endOf('month')],
                lastYear: [now.clone().subtract(1, 'year').startOf('year'), now.clone().subtract(1, 'year').endOf('year')]
            }
            if (!ranges[preset]) return

            this.range = { start: ranges[preset][0].format('YYYY-MM-DD'), end: ranges[preset][1].format('YYYY-MM-DD') }
            this.emit()
        },

        emit() {
            this.$emit('change', { ...this.range })
        }
    }
}
</script>
